import { Button, MenuItem, Stack, TextField } from '@mui/material';
import React from 'react';
import { FinsightEntityField } from 'shared';

import { InputArea } from './InputArea';

interface ConstraintsManagerProps {
  field: FinsightEntityField['schema'];
  setField: (field: FinsightEntityField['schema']) => void;
  disabled?: boolean;
}

export function ConstraintsManager({
  field,
  setField,
  disabled = false,
}: ConstraintsManagerProps) {
  return (
    <InputArea
      name="Constraints"
      description="Constraints define validation rules for this field"
    >
      {Array.isArray(field.constraints) &&
        field.constraints.map((constraint, i) => (
          <Stack
            key={i}
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              p: 2,
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
            }}
          >
            <TextField
              size="small"
              label="Name"
              value={constraint.name}
              onChange={(e) => {
                const updatedConstraints = [...(field.constraints || [])];
                updatedConstraints[i] = {
                  ...updatedConstraints[i],
                  name: e.target.value,
                };
                setField({
                  ...field,
                  constraints: updatedConstraints,
                });
              }}
              sx={{ minWidth: 150 }}
              disabled={disabled}
            />
            <TextField
              size="small"
              label="Property"
              value={constraint.property}
              onChange={(e) => {
                const updatedConstraints = [...(field.constraints || [])];
                updatedConstraints[i] = {
                  ...updatedConstraints[i],
                  property: e.target.value,
                };
                setField({
                  ...field,
                  constraints: updatedConstraints,
                });
              }}
              sx={{ minWidth: 150 }}
              disabled={disabled}
            />
            <TextField
              size="small"
              label="Operator"
              select
              value={constraint.operator}
              onChange={(e) => {
                const updatedConstraints = [...(field.constraints || [])];
                updatedConstraints[i] = {
                  ...updatedConstraints[i],
                  operator: e.target.value as
                    | 'equals'
                    | 'not_equals'
                    | 'in'
                    | 'not_in',
                };
                setField({
                  ...field,
                  constraints: updatedConstraints,
                });
              }}
              sx={{ minWidth: 120 }}
              disabled={disabled}
            >
              <MenuItem value="equals">Equals</MenuItem>
              <MenuItem value="not_equals">Not Equals</MenuItem>
              <MenuItem value="in">In</MenuItem>
              <MenuItem value="not_in">Not In</MenuItem>
            </TextField>
            <TextField
              size="small"
              label="Value"
              value={
                Array.isArray(constraint.value)
                  ? constraint.value.join(', ')
                  : String(constraint.value || '')
              }
              onChange={(e) => {
                const updatedConstraints = [...(field.constraints || [])];
                updatedConstraints[i] = {
                  ...updatedConstraints[i],
                  value: e.target.value,
                };
                setField({
                  ...field,
                  constraints: updatedConstraints,
                });
              }}
              sx={{ minWidth: 150 }}
              disabled={disabled}
            />
            <Button
              size="small"
              color="error"
              variant="outlined"
              onClick={() => {
                const updatedConstraints = (field.constraints || []).filter(
                  (_, index) => index !== i,
                );
                setField({
                  ...field,
                  constraints: updatedConstraints,
                });
              }}
              disabled={disabled}
            >
              Delete
            </Button>
          </Stack>
        ))}
      <Button
        onClick={() => {
          setField({
            ...field,
            constraints: [
              ...(Array.isArray(field.constraints) ? field.constraints : []),
              {
                name: '',
                property: '',
                operator: 'equals',
                value: '',
              },
            ],
          });
        }}
        disabled={disabled}
      >
        Add New Constraint
      </Button>
    </InputArea>
  );
}
